import { useState, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import Offcanvas from "react-bootstrap/Offcanvas";
import ClinicAppointmentsTable from "./ClinicAppointmentsTable";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Accordion from "react-bootstrap/Accordion";
import ClinicAppointmentsGrid from "./ClinicAppointmentsGrid";
import { Whisper, Tooltip } from "rsuite";
import { RiGridFill, RiListUnordered } from "react-icons/ri";
import ClinicFilterPopover from "./ClinicFilterPopover";
import { useLazyGetallappointmentsQuery, usePostFilteredAppointmentsMutation } from "../State/Api/GetallappointmentsApiSlice";
import { FiUser, FiSearch, FiX  } from "react-icons/fi";
import ClinicsideAppointmentfilters from "./ClinicsideAppointmentfilters";
import DefaultPatientFilters from "./ClinicComponent/Filters/DefaultPatientFilters";
import AppointmentViewFilters from "./ClinicComponent/Filters/ClinicFilterJSON/AppointmentView";

function ClinicAppointments() {
  const [show, setShow] = useState(false);
  const [AppointementDetail, setAppointementDetail] = useState("");
  const [selectedFilters, setSelectedFilters] = useState([]);
  const gridRef = useRef(null);
  const [hasData, setHasData] = useState(true);

    // Keep track of last applied filters
    const prevFiltersRef = useRef([]);
  
    useEffect(() => {
      // Only purge if filters actually changed
      if (
        JSON.stringify(prevFiltersRef.current) !== JSON.stringify(selectedFilters)
      ) {
        gridRef?.current?.api?.purgeInfiniteCache();
        prevFiltersRef.current = selectedFilters;
      }
    }, [selectedFilters]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [activeView, setActiveView] = useState("list");

  const getButtonClasses = (view) => {
    const isActive = activeView === view;
    return [
      "flex-1 flex items-center justify-center h-[36px] w-[50px] transition-all",
      isActive
        ? "bg-[#203342] text-white"
        : "bg-white text-[#203342] hover:bg-gray-100",
    ].join(" ");
  };

  const navigate = useNavigate();
  const clinicUserId = localStorage.getItem("userClinicID");
  const [postFilteredAppointments, { data = [], isLoading, isSuccess, isError, isFetching }] = usePostFilteredAppointmentsMutation();


   const getAppointments = async (pageNumber, filters, sortColumn = "", sortOrder = "") => {
      try {
        const result = await postFilteredAppointments({
          pageNumber: pageNumber,
          pageSize: 100,
          userClinicID: clinicUserId,
            doctorUserUniqueID: "",
          filters: filters,
          sortColumn: sortColumn,
          sortOrder: sortOrder
        }).unwrap();
        return result;
      } catch (err) {
   
      }
    };

      useEffect(() => {
        gridRef?.current?.api?.purgeInfiniteCache();
      }, [selectedFilters]);


  const handleSearch = () => {
    let searchValue = AppointementDetail.trim();

    if (!searchValue) {
      // Clear filters if search empty
      setSelectedFilters((prev) => {
        const { patientName, patientIDUniqueID, ...rest } = prev;
        return rest;
      });
      return;
    }

    let newFilter;

    if (/^PLCRXPAT\d+$/i.test(searchValue)) {
      // Already formatted Patient ID
      newFilter = {
        patientIDUniqueID: {
          values: new Set([searchValue]),
          operator: "Contains",
        },
      };
    } else if (/^\d+$/.test(searchValue)) {
      // Only numbers → prepend prefix
      const prefixedValue = `PLCRXPAT${searchValue}`;
      newFilter = {
        patientIDUniqueID: {
          values: new Set([prefixedValue]),
          operator: "Contains",
        },
      };
    } else {
      // Otherwise treat as name
      newFilter = {
        patientName: {
          values: new Set([searchValue]),
          operator: "Contains",
        },
      };
    }

    setSelectedFilters((prev) => {
      const { patientName, patientIDUniqueID, ...rest } = prev;
      return { ...rest, ...newFilter };
    });
  };

  const handleClearSearch = () => {
    setAppointementDetail("");
    setSelectedFilters((prev) => {
      const { patientName, patientIDUniqueID, ...rest } = prev;
      return rest;
    });
    setHasData(true);
  };


const tooltipStyles = {
  backgroundColor: '#1f2937',
  color: 'white',
  fontSize: '12px',
  padding: '6px 8px',
  borderRadius: '4px',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  border: 'none',
  maxWidth: '200px'
};

  return (
    <>
      <main style={{ width: "100%", height: "100%" }}>
        <div className="row">
          <div
            style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}
            className="col-12 mb-4 d-flex flex-wrap justify-content-between align-items-center gap-2"
          >
            <div className="d-flex justify-content-between">
              <div>
                <h2 className="h3 fw-bold" style={{justifyContent:'center',fontSize:'24px',marginBottom:0}}>Clinic Appointments</h2>
                {/* <p className="text-secondary">
                  Schedule and manage patient appointments with doctors.
                </p> */}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-end gap-3">
              <div className="d-flex align-items-center gap-3">

<label className="relative">
  <input
    type="text"
     maxLength={14}
    className="pr-20 pl-4 py-2 border border-[#7eb592] rounded-lg w-full text-sm focus:outline-none ring-2 ring-[#7eb592]/20 focus:outline focus:border-[#7eb592] focus:ring-2 focus:ring-[#7eb592]/20"
    placeholder="Enter patient name or ID"
    value={AppointementDetail}
    onChange={(e) => {
      const value = e.target.value;
      setAppointementDetail(value);

      if (value.trim() === "") {
        setSelectedFilters((prev) => {
          const { fullName, patientIDUniqueID, ...rest } = prev;
          return rest;
        });
      }
    }}
    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
  />
  
  {AppointementDetail && (
    <Whisper
      placement="top"
      trigger="hover"
      speaker={
        <Tooltip className="!bg-gray-800 !text-white !text-xs !px-2 !py-1 !rounded !shadow-lg">
          Clear search
        </Tooltip>
      }
    >
      <span
        className="absolute right-12 top-9 transform -translate-y-1/2 p-2 rounded-md text-gray-500 hover:text-red-400 cursor-pointer transition-colors duration-200"
        onClick={handleClearSearch}
      >
        <FiX size={16} />
      </span>
    </Whisper>
  )}

  <Whisper
    placement="bottom"
    trigger="hover"
    delay={100}
   speaker={<Tooltip style={tooltipStyles}>Search patients by name or Only last 4 digits of ID or Department</Tooltip>}
  >
    <span
      className="absolute right-[0.3rem] top-9 transform -translate-y-1/2 bg-[#7eb592] hover:bg-[#6ba080] p-2 rounded-md text-white cursor-pointer transition-colors duration-200"
      onClick={handleSearch}
    >
      <FiSearch size={16} />
    </span>
  </Whisper>
</label>



                              <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={<Tooltip>Filter Options</Tooltip>}
                  >
                    <DefaultPatientFilters
                                      defaultFilters={AppointmentViewFilters.default}
                                      additionalFilters={AppointmentViewFilters.additional}
                                      selectedFilters={selectedFilters}
                                      setSelectedFilters={setSelectedFilters}
                                      setHasData={setHasData}
                                    />
                  </Whisper>

                <button
                  className="gradient-button"
                  style={{ color: "#fff" }}
                  onClick={() => navigate("/AddAppointment")}
                >
                  + Add Appointment
                </button>

                {/* <div className="flex rounded-md overflow-hidden shadow-sm border border-gray-200 ml-[5px] w-fit">
                  <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={<Tooltip>List view</Tooltip>}
                  >
                    <button
                      onClick={() => setActiveView("list")}
                      className={getButtonClasses("list")}
                    >
                      <RiListUnordered size={20} />
                    </button>
                  </Whisper>
                  <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={<Tooltip>Grid view</Tooltip>}
                  >
                    <button
                      onClick={() => setActiveView("grid")}
                      className={getButtonClasses("grid")}
                    >
                      <RiGridFill size={20} />
                    </button>
                  </Whisper>

                  
                </div> */}
              </div>
            </div>
          </div>
        </div>

        {activeView === "list" && (
          <div className="row" style={{ width: "100%", height: "100%" }}>
            <div className="col-12 p-0">
              <ClinicAppointmentsTable
                getAppointments={getAppointments}
                isFetching={isFetching}
                isLoading={isLoading}
                isSuccess={isSuccess}
                gridRef={gridRef}
                selectedFilters={selectedFilters}
                hasData={hasData}          
                setHasData={setHasData} 
              />
            </div>
          </div>
        )}

        <Offcanvas
          show={show}
          onHide={handleClose}
          placement={"end"}
          style={{
            width: "22rem",
            margin: ".5rem .5rem",
            borderRadius: "0.5rem 0rem 0px .5rem",
          }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title
              className="text-black"
              style={{ fontSize: "18px" }}
            >
              Filters
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="d-flex flex-column gap-2">
              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Booking Date
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="position-relative div-okij8ijj mb-3">
                      <input
                        type="text"
                        className="form-control div-sdwfegere"
                        placeholder="Search"
                        style={{
                          padding: ".3rem .2rem",
                          borderRadius: ".3rem",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ top: "5px", right: ".2rem" }}
                      >
                        <button style={{ background: "none", border: "none" }}>
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Today</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Last 7 days </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Last Month </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Last 3 Months </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Last 6 Months </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Last 1 Year </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Appointment Date
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="position-relative div-okij8ijj mb-3">
                      <input
                        type="text"
                        className="form-control div-sdwfegere"
                        placeholder="Search"
                        style={{
                          padding: ".3rem .2rem",
                          borderRadius: ".3rem",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ top: "5px", right: ".2rem" }}
                      >
                        <button style={{ background: "none", border: "none" }}>
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Today</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Last 7 days </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Last Month </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Last 3 Months </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Last 6 Months </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Last 1 Year </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Doctor
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="position-relative div-okij8ijj mb-3">
                      <input
                        type="text"
                        className="form-control div-sdwfegere"
                        placeholder="Search"
                        style={{
                          padding: ".3rem .2rem",
                          borderRadius: ".3rem",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ top: "5px", right: ".2rem" }}
                      >
                        <button style={{ background: "none", border: "none" }}>
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Riya</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Swapna </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Hari Tej </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Narayana </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Prasad </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Subramanyam </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Appointement Status
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Pending</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>On Recovery </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Recovered </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Canceled </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Patient Name
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="position-relative div-okij8ijj mb-3">
                      <input
                        type="text"
                        className="form-control div-sdwfegere"
                        placeholder="Search"
                        style={{
                          padding: ".3rem .2rem",
                          borderRadius: ".3rem",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ top: "5px", right: ".2rem" }}
                      >
                        <button style={{ background: "none", border: "none" }}>
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Raju</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Ramya </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Prasanth </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Madhu </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Ravi </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Vasudev </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Time of Day
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Morning (6 AM - 12 PM)</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Afternoon (12 PM - 6 PM)</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Evening (6 PM - 10 PM)</span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Urgency Level
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Emergency cases only</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Follow - ups only</span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Recurring Appointments
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="position-relative div-okij8ijj mb-3">
                      <input
                        type="text"
                        className="form-control div-sdwfegere"
                        placeholder="Search"
                        style={{
                          padding: ".3rem .2rem",
                          borderRadius: ".3rem",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ top: "5px", right: ".2rem" }}
                      >
                        <button style={{ background: "none", border: "none" }}>
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Raju</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Ramya </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Prasanth </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Madhu </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Ravi </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Vasudev </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Appointment Duration
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>15 Mins</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>30 Mins</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>45 Mins</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>1 Houur</span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Payment Statuts
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Paid</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Unpaid</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Insurance Processing</span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </main>
    </>
  );
}

export default ClinicAppointments;
